import React, { useState } from "react";
import StepOne from "./StepOne";
import StepThree from "./StepThree";
import StepTwo from "./StepTwo";
import StepFour from "./StepFour";
import { useNavigate ,useLocation } from "react-router-dom";
import { set } from "jodit/esm/core/helpers";

const MultistepForm = () => {
   const location = useLocation();
   let step = 1;
   if(location.state != undefined && location.state != null){
      if(![undefined,null,""].includes(location.state.record_id)){
     step = 1
     }else{
      step = Number(location.state.row.step == 1)?2 : Number(location.state.row.step == 2)?4 : Number(location.state.row.step == 3)?4 : 1;
     }
   }

  const [currentStep, setCurrentStep] = useState(step);
  const [formData, setFormData] = useState({});

  // const nextStep = () => {
  //   setCurrentStep(currentStep + 1);
  // };

  // const prevStep = () => setCurrentStep(currentStep - 1);
  const nextStep = (isPackageSelected , extraData) => {
    setFormData({...formData,...extraData})
    if(isPackageSelected == false){
      setCurrentStep(currentStep + 2);
    }else if(isPackageSelected == undefined || isPackageSelected == null || isPackageSelected == true){
      setCurrentStep(currentStep + 1);
    }else{
      setCurrentStep(currentStep + 1 );
    }
  };

  const prevStep = (isPackageSelected) => 

  {
 
  if(isPackageSelected == false){
    setCurrentStep(currentStep - 2);
  }else if(isPackageSelected == undefined || isPackageSelected == null || isPackageSelected == true){
    setCurrentStep(currentStep - 1);
  }else{
    setCurrentStep(currentStep - 1);
  }
  };

  const handleChange = (input) => (e) => {
    setFormData({ ...formData, [input]: e.target.value });
  };

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <StepOne formData={formData} handleChange={handleChange } nextStep={nextStep}  prevStep={prevStep}  currentStep= {currentStep} />;
      case 2:
        return <StepTwo formData1={formData} handleChange={handleChange } nextStep={nextStep}  prevStep={prevStep}  currentStep= {currentStep} />;
      case 3:
        return <StepThree formData={formData} handleChange={handleChange } nextStep={nextStep}  prevStep={prevStep}  currentStep= {currentStep} />;
        case 4:
        return <StepFour formData1={formData} handleChange={handleChange } nextStep={nextStep}  prevStep={prevStep}  currentStep= {currentStep} />;
      default:
        return null;
    }
  };

  return (
    <div className="">
      <div className="card p-4">
        {renderStep()}
      </div>
    </div>
  );
};

export default MultistepForm;